import { render } from "./AddOrEditEventForm.vue?vue&type=template&id=78b7a83a&ts=true"
import script from "./AddOrEditEventForm.vue?vue&type=script&lang=ts"
export * from "./AddOrEditEventForm.vue?vue&type=script&lang=ts"

import "./AddOrEditEventForm.vue?vue&type=style&index=0&id=78b7a83a&lang=sass"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__